import { Divider, Flex, Stack, Text } from '@chakra-ui/react';

import React from 'react';

export const ApiIntergrationView = () => {
    return (
        <>
            <Flex>
                <Stack bg={'#FFFFFF'} p={4} borderRadius={6} w={'full'}>
                    <Text fontSize={'xl'} fontWeight={'medium'}>API Intergration.</Text>
                    <Divider/>

                    <Stack bg={'#f5f5f5'} p={6} borderRadius={6}>
                        <Text fontSize={'2xl'} fontWeight={'medium'}>Coming Soon.</Text>
                        <Text>We want you to take advantage of trucklivery business management system and intergrate it with your existing system. We&apos;ll give you all the endpoints to consume.</Text>
                    </Stack>
                </Stack>
            </Flex>
        </>
    );
};